import * as styles from "./ComboboxIcon.css";

import { clsx } from "clsx";
import { type JSX } from "react";

import { Combobox as BaseCombobox } from "@base-ui/react/combobox";
import { Icon } from "@frontend/components/atoms/Icon";

import type { ComboboxIconProps } from "./Combobox.types";

export function ComboboxIcon({
  className,
  children,
  ...props
}: ComboboxIconProps): JSX.Element {
  return (
    <BaseCombobox.Icon
      data-slot="combobox-icon"
      className={clsx(styles.icon, className)}
      {...props}
    >
      {children ?? <Icon name="ChevronDown" />}
    </BaseCombobox.Icon>
  );
}
